// removed by extract-text-webpack-plugin
module.exports = {"iframe":"_31YWK3aX7rSyRGCs_7485s"};


//////////////////
// WEBPACK FOOTER
// ./src/views/gsheet/style.css
// module id = 928
// module chunks = 0